import { Box, Typography } from '@mui/material';
import { useProspectCollections } from '../../hooks/use-prospect-collections';
import CreateCollectionButton from '../../components/organisms/create-collection-button';
import { ProspectCollectionTile } from '../../components/organisms/prospect-collection-tile';
import { useState } from 'react';
import { RenameProspectCollectionModal } from '../../components/molecules/rename-prospect-collection-modal';
import { ProspectCollectionDto } from '@zaplify/services/prospect-collections/shared';
import { useNavigate } from 'react-router-dom';
import { paths } from '../../routes/paths';

export const ProspectCollectionsView = () => {
    const { prospectCollections, archiveProspectCollection, updateProspectCollectionName } = useProspectCollections();
    const [renameModalOpen, setRenameModalOpen] = useState(false);
    const [currentCollection, setCurrentCollection] = useState<ProspectCollectionDto | null>(null);
    const navigate = useNavigate();

    const handleRename = (collectionId: string) => {
        setCurrentCollection(prospectCollections.find((pc) => pc.id === collectionId) || null);
        setRenameModalOpen(true);
    };

    const handleRenameSubmit = async (newName: string) => {
        if (currentCollection) {
            await updateProspectCollectionName(currentCollection.id, newName);
            setRenameModalOpen(false);
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
            }}
        >
            <Typography variant="h3">Prospect Collections</Typography>
            <CreateCollectionButton />
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '16px',
                }}
            >
                {prospectCollections.map((collection) => (
                    <ProspectCollectionTile
                        key={collection.id}
                        prospectCollectionDto={collection}
                        onDelete={() => archiveProspectCollection(collection.id)}
                        onRename={() => handleRename(collection.id)}
                        onClick={() => navigate(paths.PROSPECT_COLLECTIONS + '/' + collection.id)}
                    />
                ))}
            </Box>
            <RenameProspectCollectionModal
                open={renameModalOpen}
                onClose={() => setRenameModalOpen(false)}
                onSubmit={handleRenameSubmit}
                invalidNames={prospectCollections.map((pc) => pc.name)}
                oldName={currentCollection?.name || ''}
            />
        </Box>
    );
};
